import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


export default new Router({
  routes: [{
      path: '/',
      name: 'Index',
      component: resolve => require(['../Index/index.vue'], resolve),
    },
    {
      path: '/news_detail',
      name: 'NewsDetail',
      component: resolve => require(['../Index/news_detail.vue'], resolve),
    },
    {
      path: '/locate_detail',
      name: 'NewsDetail',
      component: resolve => require(['../Index/locate_detail.vue'], resolve),
    },
    //   {
    //     path: '/tab',
    //       name: 'Tab',
    //       component: resolve => require(['../Tab.vue'],resolve),
    //       // children:[
    //       //     {},
    //       // ]
    //   },
    //   {
    //       path: '/product',
    //       name: 'Product',
    //       component : resolve=> require(['../Product/product.vue'],resolve),
    //   }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js